export default __webpack_public_path__ + "static/cyberscurity-882f1c3fd30bf431097eaafb33f0079b.webp";